<template>
  <div class="how-it-works">
    <h3>How This Works</h3>
    <p>
      {{ styleStore.storeInfo?.name }} allows you to purchase gift vouchers for redemption in store using the CBE Voucher platform.
    </p>
    <p>
      You'll receive a printable PDF that you can use yourself, or gift to
      someone else.
    </p>
    <hr>
    <div class="step">
      <strong>Step 1.</strong>
      <p>Pick a quantity and fill in your details.</p>
    </div>
    <hr>
    <div class="step">
      <strong>Step 2.</strong>
      <p>
        Pay securely with your credit or debit card, or using Apple Pay or
        Google Pay.
      </p>
    </div>
    <hr>
    <div class="step">
      <strong>Step 3.</strong>
      <p>
        View and download your PDF. We will also email you a copy, along with
        your payment receipt.
      </p>
    </div>
    <hr>
    <h4 class="mt-4">
      Get Help
    </h4>
    <p>
      If you need any help, please email:
      <a :href="`mailto:${styleStore.generalInfo?.email || styleStore.storeInfo?.email}`"><strong>{{ styleStore.generalInfo?.email || styleStore.storeInfo?.email }}</strong></a>
    </p>
    <div class="payments">
      <ul>
        <li>
          <img
            src="@/images/apple-pay.svg"
            alt=""
          >
        </li>
        <li>
          <img
            src="@/images/visa.svg"
            alt=""
          >
        </li>
        <li>
          <img
            src="@/images/mastercard.svg"
            alt=""
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { useStyleStore } from "../stores/styleStore";

export default {
  name: "HowItWorks",
  data() {
    return {
      styleStore: useStyleStore(),
    };
  },
};

</script>
<style>
.payments {
  margin-top: 20px;
}
.payments ul {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: space-between;
}
.payments li {
  flex: 1;
}
.payments img {
  max-width: 75px;
  height: auto;
}
</style>
